module.exports = __webpack_public_path__ + "static/media/carteractual.15c79f3c.png";